/**
 * Limit number of options returned by `useAutocomplete` to avoid UI performance
 * issues.
 */
export function limitOptions(options, limit) {
  return {
    limitedOptions: options.slice(0, limit),
    limited: options.length > limit
  };
}

/**
 * Limit number of grouped options returned by `useAutocomplete` to avoid UI
 * performance issues.
 */
export function limitGroupedOptions(groups, limit) {
  let limited = false;
  const limitedGroups = [];
  for (const group of groups) {
    if (limit <= 0) {
      limited = true;
      break;
    } else if (group.options.length > limit) {
      limitedGroups.push({
        ...group,
        options: group.options.slice(0, limit)
      });
      limited = true;
      break;
    } else {
      limitedGroups.push(group);
      limit -= group.options.length;
    }
  }
  return {
    limitedGroups,
    limited
  };
}